import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rIstatistikSonuc_4, rValue } from '../../models/.catalog';

export default class OyakDegerlemeToplamDegerApi extends ApiBase<
  pList,
  rValue<rIstatistikSonuc_4>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakDegerlemeToplamDeger',
      }),
      options
    );
  }
}
